import React from "react";
import { useSpendingDemandPaymentSummary } from "../../../../hooks";
import { numberToStingWithSpaces } from "../../../../../../utils/numberDisplayer";

interface OrgPayedRendererProps {
  spendingDemandId: string;
}

export const OrgPayedRenderer: React.FC<OrgPayedRendererProps> = ({ spendingDemandId }) => {
  const { paymentSummary, isLoading } = useSpendingDemandPaymentSummary(spendingDemandId, {
    disableQuery: !spendingDemandId,
  });

  if (isLoading) {
    return <span style={{ color: "#999", fontSize: "0.8rem" }}>...</span>;
  }

  if (!paymentSummary.totalPayedOrg || paymentSummary.totalPayedOrg === 0) {
    return <span style={{ color: "#999" }}>-</span>;
  }

  return <span>{numberToStingWithSpaces(paymentSummary.totalPayedOrg)}</span>;
};

export default OrgPayedRenderer;
